export default function getSubtotal(cartItems = []) {
  if (cartItems === undefined) return 0
  return cartItems
    .map(cartItem => cartItem.price * cartItem.quantity)
    .reduce((a, b) => a + b, 0)
}
